<template>
  <div class="bg_box "
       v-loading="firstLoading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <!--顶部banner-->
    <Banner :form.sync="form" :send-message="sendMessage" :type="2" :bannerTitle="orgName"/>

    <div class="dashboard-container ">

      <!--时间范围选择-->
      <TimeSelect :form.sync="form" :send-message="sendMessage"/>


      <div class="dashboard-layout">
        <!-- 左侧面板 -->
        <div class="panel-group left-panel">
          <!--销售数据-->
          <Salesdata
              :name="get_time()"
              :module="form.module"
              :salesdata="detail.sales_block"/>
          <!--招商排行-->
          <InvestmentRank :name="get_time()"
                          :institution_partner_detail_rank_block="detail.institution_partner_detail_rank_block"
                          :rankblock="detail.institution_partner_rank_block"
                          :form.sync="form"
                          :send-message="sendMessage"/>
        </div>

        <!-- 中间内容区 -->
        <div class="center-content">
          <!--GMV-->
          <GMV :name="get_time()" :GMVform="detail.gmv_block"/>
          <!--兵工场销售占比-->
          <div class="map-container">
            <OrgPie
                title="兵工场销售占比"
                :datas="detail.bing_factory_sales_pie_block"
                nameField="factory_name"
            />
          </div>
        </div>

        <!-- 右侧面板 -->
        <div class="panel-group right-panel">
          <!--订单数据,GMV数据-->
          <RightTop :name="get_time()" :chartblock="detail.sales_chart_block"/>
          <!--产品分类-->
          <ProductCategory :category_sales_pie_block="detail.category_sales_pie_block"/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import OrgPie from '@/components/charts/pie3d.vue'
import Home from '../home.vue'
import GMV from './components/gmv.vue'
import Socket from '@/utils/websocket'
import Salesdata from './components/salesdata.vue'
import RightTop from './components/right_top.vue'
import Banner from './components/banner.vue'
import TimeSelect from './components/timeSelect.vue'
import InvestmentRank from './components/orgComponents/InvestmentRank.vue'
import ProductCategory from '@/components/charts/pie2d.vue'
import {tFormatDate} from '@/utils/utils';

export default {
  name: 'BgcOne',
  components: {
    OrgPie,
    Home,
    GMV,
    Salesdata,
    RightTop,
    Banner,
    TimeSelect,
    InvestmentRank,
    ProductCategory,
  },
  data() {
    return {
      orgName: '',

      firstLoading: true,

      socket: null,
      messages: [],
      error: null,
      wsUrl: ``,

      // wsUrl: 'wss://mp-dev.bobiton.com:9503/wsDataScreen/ws',

      form: {
        module: 6, // 模块 1兵工场 2机构 3分销者 4产品 5单兵工场 6单机构 7分销者实时数据汇总
        platform: 1, // 平台 1快手 2视频号 3抖音
        date_type: 0, // 时间类型：0时间选择 1自定义时间
        date_value: 1, // 时间选择 1今日 2昨日 3本月 4上月（当时间类型为0时必传 为1的时候传0）
        date_start: '', // 开始时间（当时间类型为1时必传 为0的时候传''）
        date_end: '', // 结束时间（当时间类型为1时必传 为0的时候传''）
        position: 0, // 是否拿取分销者数据
        module_user_id: '',
      },
      detail: {
        gmv_block: {
          current_sum_pay_amount: 0,//当前筛选gmv
          current_count_order: 0,//当前筛选订单量
          previous_sum_pay_amount: 0,//上期gmv
          previous_desc: '--',//上期描述文字
          gmv_growth: 0,//同比增长
          all_sum_pay_amount: 0,//累计gmv
        }, // gmv中心块
        sales_block: {
          current_count_order: 0,
          current_settle_count_order: 0,
          current_sum_pay_amount: 0,
          current_settle_sum_pay_amount: 0,
          current_sum_service_amount: 0,
          current_settle_sum_service_amount: 0,
          current_send_sample_count: 0,
          current_distinct_talent_num: 0
        }, // 销售数据（左上）
        sales_chart_block: {}, // 订单折线图（右上）
        bing_factory_sales_pie_block: [],//兵工场销售占比

        institution_partner_rank_block: [],//招商排行
        institution_partner_detail_rank_block: {//招商排行详情
          census_data: {},
          current_page: 0,
          last_page: 0,
          list: [],
          per_page: 10,
          total: 0
        },

        category_sales_pie_block: {}//产品分类
      },

    }
  },

  mounted() {
    this.form.module_user_id = this.$route.query.orgId
    this.form.platform = this.$route.query.platform
    this.orgName = this.$route.query.orgName+'机构数据'
    this.connectWebSocket()
  },
  methods: {
    get_time() {
      if (this.form.date_type === 0) {
        if (this.form.date_value === 1) {
          return '今日'
        } else if (this.form.date_value === 2) {
          return '昨日'
        } else if (this.form.date_value === 3) {
          return '本月'
        } else if (this.form.date_value === 4) {
          return '上月'
        } else {
          return `自定义时间`
        }
      } else {
        return ``
      }

    },
    // 连接WebSocket
    connectWebSocket() {
      if (this.socket) {
        this.socket.close();
      }

      this.socket = new Socket(
          this.wsUrl,
          this.handleMessage,
          this.handleError
      );

      // 添加连接成功回调
      this.socket.onOpen = () => {
      };

      this.socket.connect();
    },


    // 处理接收到的消息
    handleMessage(data) {
      if (data == 'pong') {
        return
      }

      if (data.data === '连接成功') {
        this.sendMessage(); // 确保连接成功后再发送
      } else if (data.code == 400) {
        this.firstLoading = false
        this.$message.error(data.message);
      } else {
        this.firstLoading = false
        // gmv中心块
        if (data.data.gmv_block) {
          this.detail.gmv_block = data.data.gmv_block
        }
        // 销售数据（左上）
        if (data.data.sales_block) {
          this.detail.sales_block = data.data.sales_block
        }
        // 订单折线图（右上）
        if (data.data.sales_chart_block) {
          this.detail.sales_chart_block = data.data.sales_chart_block
        }
        // 兵工场销售占比
        if (data.data.bing_factory_sales_pie_block) {
          this.detail.bing_factory_sales_pie_block = data.data.bing_factory_sales_pie_block

        }

        // 招商排行
        if (data.data.institution_partner_rank_block) {
          this.detail.institution_partner_rank_block = data.data.institution_partner_rank_block
        }
        // 招商排行（详情
        if (data.data.institution_partner_detail_rank_block) {
          this.detail.institution_partner_detail_rank_block = data.data.institution_partner_detail_rank_block
        }

        // 产品分类
        if (data.data.category_sales_pie_block) {
          this.detail.category_sales_pie_block = data.data.category_sales_pie_block
        }
      }
    },

    // 处理错误
    handleError(error) {
      this.error = error.message || 'WebSocket连接错误'
    },
    // 发送消息
    sendMessage() {
      if (this.socket) {
        this.firstLoading = true
        this.socket.send(this.form)
      } else {
        this.error = '请先连接WebSocket'
      }
    },

    // 关闭连接
    closeWebSocket() {
      if (this.socket) {
        this.socket.close()
        this.socket = null
      }
    }
  },

  // 组件销毁时关闭WebSocket
  beforeDestroy() {
    if (this.socket) {
      this.socket.close()
    }
  },
}
</script>

<style lang="scss" scoped>

.bg_box {
  //width: 100%;
  height: 100vh;
  background-image: url(../../assets/iamge_bg.png);
  background-size: 100% 100vh;
}

.dashboard-container {
  padding: 0 20px;
}


.dashboard-layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.panel-group {
  display: flex;
  flex-direction: column;

  &.left-panel {
    margin-right: auto;
  }

  &.right-panel {
    margin-left: auto;
  }
}

.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  &.first-panel {
    margin: 30px 0 35px 0;
  }
}

.center-content {
  width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.map-container {
  width: 100%;
  height: 640px;
}


// ::v-deep .el-input__icon {
//   line-height: 30px !important;
//   font-size: 22px !important;
//   color: #00A8FF !important;
// }

</style>